module.exports = require("live/context/widget");